module.exports = __webpack_public_path__ + "img/BS_crosshairs_B.2360dcdc.svg";